import React, { useEffect, useState } from 'react';

const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';

export const DecryptedText = ({ text, className = '', delay = 0 }) => {
  const [displayText, setDisplayText] = useState(text);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Reset quando cambia il testo (cambio lingua)
    setDisplayText(text);
    setIsVisible(false);
    
    const timeout = setTimeout(() => {
      setIsVisible(true);
      let iteration = 0;
      const interval = setInterval(() => {
        setDisplayText(
          text
            .split('')
            .map((char, index) => {
              if (index < iteration) {
                return text[index];
              }
              return characters[Math.floor(Math.random() * characters.length)];
            })
            .join('')
        );

        if (iteration >= text.length) {
          clearInterval(interval);
        }

        iteration += 1 / 3;
      }, 30);

      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timeout);
  }, [text, delay]); // Aggiunto text come dipendenza

  return (
    <span 
      className={className}
      style={{
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        display: 'inline-block',
        minHeight: '1em'
      }}
    >
      {displayText}
    </span>
  );
};